import { render, staticRenderFns } from "./ProductCard.Vue?vue&type=template&id=67c917ea"
import script from "./ProductCard.Vue?vue&type=script&lang=js"
export * from "./ProductCard.Vue?vue&type=script&lang=js"
import style0 from "./ProductCard.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductCard.Vue
// module id = 63
// module chunks = 0